// extracted by mini-css-extract-plugin
export default {"ModalForm":"modal-form_ModalForm__+aXOS","ModalForm__textSubmit":"modal-form_ModalForm__textSubmit__XwDkh"};